module.exports = __webpack_public_path__ + "static/media/smilow_jason.03f83c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pillcards/smilow_jason.png
// module id = 1750
// module chunks = 0